import { AnyAction } from "redux";
import { call, put, select, takeLatest } from "redux-saga/effects";

import { RootState } from "../../../store";
import { GET_TEAM_SUCCESS } from "../../myTeam/constants";
import {
  GET_SERVICES_AGENDA_TEAM,
  GET_SERVICES_AGENDA_TEAM_FAILED,
  GET_SERVICES_AGENDA_TEAM_SUCCESS,
  TOGGLE_CREATE_ERP,
  TOGGLE_CREATE_SERVICES,
} from "../constants";
import * as Services from "../services";

function* createServices(action: AnyAction) {
  try {
    const response: any = yield call(Services.createCommandes, action.services);
    response.data.message === "Created"
      ? action.resolve()
      : action.reject(response.data.message);
  } catch (e) {
    action.reject(e);
  }
}

function* createERP(action: AnyAction) {
  try {
    const response: any = yield call(Services.createERP, action.erp);
    response.data.message === "OK"
      ? action.resolve()
      : action.reject(response.data.message);
  } catch (e) {
    action.reject(e);
  }
}

function* getServicesAgendaTeam(action: AnyAction) {
  const { startDate, endDate, agencyId } = action.payload;

  const operators = yield select(
    (state: RootState) => state.teamReducer.operators,
  );

  try {
    const payload: any = yield call(
      Services.getServicesAgendaTeam,
      agencyId,
      startDate,
      endDate,
    );
    yield put({
      type: GET_SERVICES_AGENDA_TEAM_SUCCESS,
      payload: payload.services,
    });

    const areIdsEqual = operators.every((operator: any) =>
      payload.operators.some(
        (payloadOperator: any) => payloadOperator.id === operator.id,
      ),
    );

    if (!areIdsEqual || operators?.length === 0) {
      yield put({ type: GET_TEAM_SUCCESS, payload: operators });
    }

    action.resolve(true);
  } catch (error) {
    action.reject(error);
    yield put({ type: GET_SERVICES_AGENDA_TEAM_FAILED, error });
  }
}

export const serviceOrderingSagas = [
  takeLatest(TOGGLE_CREATE_SERVICES, createServices),
  takeLatest(TOGGLE_CREATE_ERP, createERP),
  takeLatest(GET_SERVICES_AGENDA_TEAM, getServicesAgendaTeam),
];
